(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  selectOutcomeInfoChoises,
  selectShowMatchAnalyseForecast,
  selectTipsinfo
} = svs.components.tipsen.selectors;
const {
  tipsinfo
} = svs.components.tipsen.engine.constants;
const {
  selectEventStatistic,
  selectSportEvent,
  selectBetEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  AnalysisForecast,
  TipsinfoRow,
  TipsinfoRowText,
  TipsinfoRowStats,
  Trend
} = svs.components.tipsen.tipsinfo;
const {
  createEventStatisticsKey,
  createBetEventKey
} = svs.components.sportinfo.common.helpers;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  createSelectFormattedDistribution,
  createSelectFormattedOdds,
  formatDecimalOdds,
  formatPercentage,
  getOddsCaption,
  TipsInfoState
} = svs.components.tipsen.tipsinfo.utils;

const Tipsinfo = _ref => {
  var _tioTidningarTips$cur, _tioTidningarTips$cur2;
  let {
    drawNumber,
    productId,
    eventNumber,
    outcomeLabels,
    tipsInfoState = TipsInfoState.None,
    tipsinfoSupport,
    svenskaFolketState,
    outcomeInfoChoisesStateDisplay,
    oddsState,
    favouritesState
  } = _ref;
  const betEvent = useSelector(state => selectBetEvent(state, createBetEventKey(productId, drawNumber, eventNumber))) || {};
  const {
    matchId,
    eventTypeId,
    participants: participantIds
  } = betEvent;
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const isHead2Head = betEvent.eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const eventStatistics = useSelector(state => selectEventStatistic(state, createEventStatisticsKey({
    matchId,
    eventTypeId,
    participantIds
  })));
  const selectFormattedOdds = createSelectFormattedOdds(matchId, eventTypeId, participantIds);
  const selectFormattedDistribution = createSelectFormattedDistribution({
    matchId,
    eventTypeId,
    participantIds,
    productId,
    drawNumber
  });
  const tipsinfoState = useSelector(selectTipsinfo);
  const outcomeInfoChoisesState = useSelector(selectOutcomeInfoChoises);
  const {
    favourites,
    startOdds,
    tioTidningarTips
  } = eventStatistics || {};
  const shouldDisplayLargeTipsinfo = outcomeInfoChoisesStateDisplay === 'svenskaFolket';
  const shouldDisplaySvenskaFolket = tipsinfoSupport[tipsinfo.SvenskaFolket] && (outcomeInfoChoisesStateDisplay !== 'svenskaFolket' || tipsInfoState === TipsInfoState.ReduceFree) && svenskaFolketState;
  const shouldDisplayOdds = tipsinfoSupport[tipsinfo.Odds] && outcomeInfoChoisesState.display !== 'odds' && oddsState && !isHead2Head;
  const shouldDisplayStartOdds = tipsinfoSupport[tipsinfo.StartOdds] && outcomeInfoChoisesState.display !== 'startOdds' && tipsinfoState.startOdds.state;
  const shouldDisplayTioTidningar = tipsinfoSupport[tipsinfo.TioTidningar] && outcomeInfoChoisesState.display !== 'tioTidningar' && tipsinfoState.tioTidningar.state && !isHead2Head;
  const shouldDisplayMatchstart = tipsinfoSupport[tipsinfo.Matchstart] && tipsinfoState.matchStart.state;
  const hasTipsinfoStats = shouldDisplayOdds || shouldDisplayStartOdds || shouldDisplaySvenskaFolket || shouldDisplayTioTidningar;
  const shouldDisplayFavourites = tipsinfoSupport[tipsinfo.Favourites] && favouritesState;
  const showMatchAnalyseForecast = useSelector(selectShowMatchAnalyseForecast);
  const showMatchAnalyseForecastAndSupported = tipsinfoSupport[tipsinfo.Analys] && showMatchAnalyseForecast;
  const hasTioTidningarValues = (tioTidningarTips === null || tioTidningarTips === void 0 ? void 0 : (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 ? void 0 : (_tioTidningarTips$cur2 = _tioTidningarTips$cur.value) === null || _tioTidningarTips$cur2 === void 0 ? void 0 : _tioTidningarTips$cur2.length) > 0;
  const outcomeLabelsLength = (outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.length) || 0;
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  return React.createElement("div", {
    className: "tipsinfo tipsinfo-".concat(outcomeLabelsLength, "col")
  }, tipsInfoState === TipsInfoState.ReduceFree && hasTipsinfoStats && React.createElement(TipsinfoRow, {
    className: "tipsinfo-bet-options-headers",
    dataTestid: "coupon-row-tipsinfo-bet-options-headers"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels && outcomeLabels.map(el => React.createElement("div", {
    className: "f-center",
    key: el.text
  }, el.text)))), shouldDisplaySvenskaFolket && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-svenska-folket",
    title: "Svenska folket"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels && outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    postfixSymbol: "%",
    selectorFunction: selectFormattedDistribution(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-odds",
    title: getOddsCaption({
      startOddsState: tipsinfoState.startOdds.state,
      tipsInfoState
    })
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels && outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    selectorFunction: selectFormattedOdds(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayFavourites && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-favourites",
    title: "Favoritskap"
  }, React.createElement(TipsinfoRowStats, {
    className: shouldDisplayLargeTipsinfo ? 'tipsinfo-row-stats-option--lg' : '',
    sign: "%"
  }, outcomeLabels && outcomeLabels.map((_, i) => {
    var _favourites$current;
    return formatPercentage(favourites === null || favourites === void 0 ? void 0 : (_favourites$current = favourites.current) === null || _favourites$current === void 0 ? void 0 : _favourites$current.value[i]);
  }))), shouldDisplayStartOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-start-odds",
    title: "Startodds"
  }, React.createElement(TipsinfoRowStats, null, outcomeLabels && outcomeLabels.map((_, i) => {
    var _startOdds$current;
    return formatDecimalOdds(startOdds === null || startOdds === void 0 ? void 0 : (_startOdds$current = startOdds.current) === null || _startOdds$current === void 0 ? void 0 : _startOdds$current.value[i]);
  }))), shouldDisplayTioTidningar && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-ten-papers",
    title: "Tio Tidningar"
  }, React.createElement(TipsinfoRowStats, {
    noValueSign: hasTioTidningarValues ? '0' : '-'
  }, outcomeLabels && outcomeLabels.map((_, i) => {
    var _tioTidningarTips$cur3;
    return tioTidningarTips === null || tioTidningarTips === void 0 ? void 0 : (_tioTidningarTips$cur3 = tioTidningarTips.current) === null || _tioTidningarTips$cur3 === void 0 ? void 0 : _tioTidningarTips$cur3.value[i];
  }))), shouldDisplayMatchstart && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), shouldDisplayMatchstart && React.createElement(TipsinfoRow, {
    className: "coupon-row-tips-info-matchstart",
    dataTestid: "coupon-row-tips-info-matchstart",
    date: sportEvent.matchStart,
    isGoalCount: isGoalCount,
    title: "".concat(isGoalCount ? 'Matchstart' : 'Matchstart:')
  }, React.createElement(TipsinfoRowText, {
    className: "tipsinfo-row-matchstart margin-left-half"
  }, svs.components.lbUtils.helpers.formatDate.formatDate(sportEvent.matchStart, true, true, true))), showMatchAnalyseForecastAndSupported && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), showMatchAnalyseForecastAndSupported && React.createElement(AnalysisForecast, {
    dataTestid: "coupon-row-tips-info-analyse",
    drawId: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.tipsinfo.Tipsinfo', Tipsinfo);

 })(window);